import { Media, ImageMedia, VideoMedia } from '../../types/__generated__';

export function onlyImages<T extends Pick<Media, '__typename'>>(
  media: T | ImageMedia | VideoMedia,
): media is ImageMedia {
  return media.__typename === 'ImageMedia';
}

export function notNull<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}
